import { FieldValues } from "react-hook-form";
import { FormController } from "./FormController";
import { FormWrapper, IFormWrapperProps } from "./FormWrapper";

const IAM_ROLE_ARN = /^arn:aws[a-z-]*:iam::[0-9]{12}:role\/[a-zA-Z0-9+=,.@/_-]+$/;

const REDSHIFT_REGIONS = new Set([
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-south-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ca-central-1",
  "eu-central-1",
  "eu-central-2",
  "eu-north-1",
  "eu-south-1",
  "eu-south-2",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-gov-east-1",
  "us-gov-west-1",
  "us-west-1",
  "us-west-2",
]);

const validateArn = (value: string) =>
  IAM_ROLE_ARN.test(value) || "Must be a valid IAM role ARN (arn:aws:iam::123456789012:role/RoleName)";

const validateRegion = (value: string) =>
  REDSHIFT_REGIONS.has(value) || "Must be an AWS region that supports Redshift (e.g. us-west-2)";

const RedshiftEditor = <T extends FieldValues>(props: IFormWrapperProps<T>) => (
  <FormWrapper {...props}>
    <FormController
      elementType="textField"
      type="text"
      fieldName="cluster_id"
      label="Cluster Identifier"
      placeholder="my-redshift-cluster"
      rules={{ required: true }}
    />
    <FormController
      elementType="textField"
      type="text"
      fieldName="database"
      label="Database"
      placeholder="analytics"
      rules={{ required: true }}
    />
    <FormController
      elementType="textField"
      type="text"
      fieldName="db_user"
      label="Database User"
      placeholder="switchboard"
      rules={{ required: true }}
    />
    <FormController
      elementType="textField"
      type="text"
      fieldName="s3_bucket"
      label="S3 Bucket"
      placeholder="my-redshift-bucket/prefix"
      rules={{ required: true }}
    />
    <FormController
      elementType="textField"
      type="text"
      fieldName="customer_role_arn"
      label="Customer Role ARN"
      placeholder="arn:aws:iam::123456789012:role/MyRole"
      rules={{ required: true, validate: validateArn }}
    />
    <FormController
      elementType="textField"
      type="text"
      fieldName="s3_copy_role_arn"
      label="S3 Copy Role ARN"
      placeholder="arn:aws:iam::123456789012:role/RedshiftS3Access"
      rules={{ required: true, validate: validateArn }}
    />
    <FormController
      elementType="textField"
      type="text"
      fieldName="region"
      label="Region"
      placeholder="us-west-2"
      rules={{ required: true, validate: validateRegion }}
    />
    <FormController
      elementType="textField"
      type="text"
      fieldName="external_id"
      label="External ID for Role Assumption (optional)"
      placeholder="public"
    />
  </FormWrapper>
);

export { RedshiftEditor };
